// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pFzQ","select":"styles_select__3LCxU"};